export default class TextFileDownloader {

  //constructor(data = {}) {
  constructor(data) {
    this.data = data;
    //this.element = document.querySelector('.my-element');
  }

  download(mimeType="text/plain", filename=`eddi${monthscale}mo-${monthend}mm.txt`, event) {
    //let body = document.body;
    //const a = document.createElement("a");

    //let link = this.querySelector(linkSelector);
    let link = event.target;

    link.setAttribute("download", filename);

    link.href = URL.createObjectURL(new Blob([this.data], {
      type: mimeType
    }));

    //link.click();
    /*a.href = URL.createObjectURL(new Blob([JSON.stringify(this.data, null, 2)], {
      type: type_of
    }));*/
    
    //a.setAttribute("download", filename);
    //body.appendChild(a);
    //a.click();
    //body.removeChild(a);
  }
}